import React, { useState, useEffect } from "react";
import { Box, createTheme, Stack, Typography, Grid } from "@mui/material";
import { useStateValue } from "../../../StateProvider";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import OverviewContainer from "./OverviewContainer";
import PriceDetailsContainer from "./PriceDetailsContainer";
import FinancialsContainer from "./FinancialsContainer";

import { styled } from "@mui/system";
import { makeStyles } from "@mui/styles";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import StockComparison from "./StockComparison";

const NavigationBtn = styled("span")({
  fontSize: "0.8rem",
  fontWeight: "300",
  fontFamily: "primaryFont.main",
  padding: "6px 9px",
  borderRadius: "8px",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#2d79db22",
    cursor: "pointer",
  },
  color: "fontPrimaryColor.main",
});

const useStyles = makeStyles({
  selectedNB: {
    backgroundColor: "#2d79db22",
    // color: "#0aa86c",
  },
  // unSelectedNB: {
  //   padding: "12px 20px",
  //   fontSize: " 0.875rem",
  //   cursor: "pointer",
  //   fontWeight: "400",
  //   lineHeight: "1.57",
  //   transition: "all 0.3s ease",
  // },
  label: {},
  data: {},
});

const CompleteStockDetails = ({ symbol, mode }) => {
  const navigate = useNavigate();
  const [{ token }] = useStateValue();
  const params = useParams();
  const [price, setPrice] = useState(-1);
  const [show, setShow] = useState("price");
  const [stockData, setStockData] = useState({});
  const [companyData, setCompanyData] = useState({});
  const [stockStat, setStockStat] = useState({});
  const [advanceStockStat, setAdvanceStockStat] = useState({});

  const [selected, setSelected] = useState("price");
  const [stocksToCompare, setStocksToCompare] = useState([]);
  const [openComparison, setOpenComparison] = useState(false);

  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/company?token=${token}`
      )
      .then((res) => {
        setCompanyData(res.data);
        // console.log("comapny", res.data);
      })
      .catch((err) => console.log(err));

    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/quote?period=annual&&last=16&&token=${token}`
      )
      .then((res) => {
        // console.log("stock data", res.data);
        setStockData(res.data);
      })
      .catch((err) => console.log(err));
    axios
      .get(
        ` https://cloud.iexapis.com/stable/stock/${params?.symbol}/stats?token=${token}`
      )
      .then((res) => {
        // console.log("stock stat", res.data);
        setStockStat(res.data);
      })
      .catch((err) => console.log(err));

    axios
      .get(
        ` https://cloud.iexapis.com/stable/stock/${params?.symbol}/advanced-stats?token=${token}`
      )
      .then((res) => {
        // console.log("stock advance stat", res.data);
        setAdvanceStockStat(res.data);
      })
      .catch((err) => console.log(err));

    // axios
    //   .get(
    //     ` https://cloud.iexapis.com/stable/time-series/REPORTED_FINANCIALS/${params?.symbol}/10-K?token=${token}`
    //   )
    //   .then((res) => {
    //     console.log("annual report", res.data);
    //   })
    //   .catch((err) => console.log(err));
    /****************/
  }, []);

  const classes = useStyles();
  const round = (n) => {
    return n ? +n.toFixed(2) : null;
  };
  return (
    <Box className="complete__stock__details">
      {openComparison ? (
        <>
          <Box
            sx={{
              padding: "10px 0",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontSize: "2rem",
                fontFamily: "public sans",
                color: "fontPrimaryColor.main",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <CompareArrowsIcon sx={{ fontSize: "40px" }} /> Compare
            </Typography>
          </Box>
          <StockComparison mode={mode} />
        </>
      ) : (
        <>
          <Box
            sx={{
              padding: { xs: "10px 10px", sm: "10px 0" },
              display: "flex",
              justifyContent: { xs: "space-around", sm: "space-between" },
            }}
          >
            <Typography
              sx={{
                fontSize: "2rem",
                fontFamily: "public sans",
                color: "fontPrimaryColor.main",
                textTransform: "uppercase",
                marginLeft: { xs: "10px", sm: "0" },
              }}
            >
              {symbol}
            </Typography>
            <Grid
              container
              sx={{
                width: { xs: "100px", sm: "300px" },
              }}
            >
              <Grid item xs={3} sm={6}>
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "public sans",
                    fontWeight: "300",
                    color: "fontSecondaryColor?.main",
                    color: "fontPrimaryColor.main",
                    display: { xs: "none", sm: "flex" },
                  }}
                >
                  Price
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    fontFamily: "public sans",
                    color: "fontPrimaryColor.main",
                    // display: "inline",
                  }}
                >
                  {stockData?.latestPrice && (
                    <>${round(stockData?.latestPrice)}</>
                  )}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "public sans",
                    display: "inline",
                    margin: "0px 3px 0 0",

                    color:
                      stockData?.change > 0
                        ? "ourGreenColor.main"
                        : "ourRedColor.main",
                  }}
                >
                  {stockData?.change && (
                    <>
                      {!stockData?.change
                        ? "N/A"
                        : stockData?.change > 0
                        ? "+" + stockData?.change
                        : stockData?.change}
                    </>
                  )}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "public sans",
                    display: "inline",
                    color:
                      stockData?.change > 0
                        ? "ourGreenColor.main"
                        : "ourRedColor.main",
                  }}
                >
                  {stockData?.changePercent && (
                    <>({round(stockData?.changePercent)}%)</>
                  )}
                </Typography>
              </Grid>
              <Grid
                item
                xs={3}
                sm={6}
                sx={{ display: { xs: "none", sm: "block" } }}
              >
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "public sans",
                    fontWeight: "300",
                    color: "fontPrimaryColor.main",
                  }}
                >
                  Market Cap
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    fontFamily: "public sans",
                    color: "fontPrimaryColor.main",
                  }}
                >
                  {!stockData?.marketCap
                    ? "N/A"
                    : `$${numFormatter(stockData?.marketCap)}`}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Stack
            spacing={1}
            direction="row"
            sx={{
              width: "100%",
              margin: "20px 0px",
              justifyContent: { xs: "center", sm: "left" },
            }}
          >
            <NavigationBtn
              onClick={() => setSelected("price")}
              className={selected == "price" && classes?.selectedNB}
              sx={{ color: "fontPrimaryColor.main" }}
            >
              PRICE
            </NavigationBtn>
            <NavigationBtn
              onClick={() => setSelected("financials")}
              className={selected == "financials" && classes?.selectedNB}
              sx={{ color: "fontPrimaryColor.main" }}
            >
              FINANCIALS
            </NavigationBtn>
            <NavigationBtn
              onClick={() => setSelected("overview")}
              className={selected == "overview" && classes?.selectedNB}
              sx={{ color: "fontPrimaryColor.main" }}
            >
              OVERVIEW
            </NavigationBtn>
          </Stack>
          {selected == "overview" && (
            <OverviewContainer companyData={companyData} />
          )}
          {selected == "price" && (
            <PriceDetailsContainer
              stockData={stockData}
              stockStat={stockStat}
              mode={mode}
            />
          )}
          {selected == "financials" && (
            <FinancialsContainer
              stockData={stockData}
              stockStat={stockStat}
              advanceStockStat={advanceStockStat}
              mode={mode}
              token={token}
              setOpenComparison={setOpenComparison}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default CompleteStockDetails;

function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
}
